export const addCommaInNumber = (number: number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const calculatePercentage = (value: number, total: number) => {
  return (value / total) * 100;
};

export function fixedNumber(number: number, fixed = 2) {
  return number ? number?.toFixed(fixed) : 0;
}

export const addZero = (n: number = 0) =>
  (n < 0 ? "-" : "") + Math.abs(n).toString().padStart(2, "0");

export const enToBnNumber = (num: number | string) => {
  const map: Record<string, string> = {
    "0": "০",
    "1": "১",
    "2": "২",
    "3": "৩",
    "4": "৪",
    "5": "৫",
    "6": "৬",
    "7": "৭",
    "8": "৮",
    "9": "৯",
  };

  return num.toString().replace(/[0-9]/g, (d) => map[d]);
};

export const commaNumber = (num?: number | string) => {
  return Number(num || 0).toLocaleString("en-IN");
};
